import { render, staticRenderFns } from "./uploadSoftware.vue?vue&type=template&id=44710161&scoped=true&"
import script from "./uploadSoftware.vue?vue&type=script&lang=js&"
export * from "./uploadSoftware.vue?vue&type=script&lang=js&"
import style0 from "./uploadSoftware.vue?vue&type=style&index=0&id=44710161&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44710161",
  null
  
)

export default component.exports